const containerBox = {
  padding: "1.5rem",
  margin: 0,
};

const overviewPaper = {
  padding: "2rem",
  marginBottom: "1.5rem",
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
  border: "1px solid #e5e7eb",
  backgroundColor: "#ffffff",
};

const headerSection = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "1.5rem",
  flexWrap: "wrap",
  gap: "1rem",
};

const titleSection = {
  flex: 1,
  minWidth: "300px",
};

const titleTypography = {
  fontWeight: 600,
  fontSize: "1.75rem",
  color: "#111827",
  marginBottom: "0.5rem",
  lineHeight: 1.3,
};

const sourceChip = {
  height: "24px",
  fontSize: "0.75rem",
  fontWeight: 600,
  borderRadius: "4px",
  marginTop: "0.5rem",
};

const infoSection = {
  marginBottom: "1.5rem",
  padding: "1rem",
  backgroundColor: "#f9fafb",
  borderRadius: "8px",
  border: "1px solid #e5e7eb",
};

const subjectText = {
  color: "#6b7280",
  fontSize: "0.875rem",
  fontWeight: 500,
  marginBottom: "0.25rem",
};

const senderEmailText = {
  color: "#111827",
  fontSize: "0.9375rem",
  fontWeight: 500,
};

const senderEmailsContainer = {
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
  flexWrap: "wrap",
};

const senderEmailsLabel = {
  color: "#6b7280",
  fontSize: "0.8125rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const senderEmailsList = {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  flexWrap: "wrap",
};

const senderEmailChip = {
  backgroundColor: "#f0f9ff",
  color: "#0369a1",
  fontSize: "0.8125rem",
  fontWeight: 500,
  height: "24px",
  borderRadius: "6px",
  border: "1px solid #bae6fd",
  "& .MuiChip-label": {
    padding: "0 8px",
    fontFamily: "monospace",
  },
};

const divider = {
  margin: "1.5rem 0",
  borderColor: "#e5e7eb",
};

const statsGrid = {
  display: "grid",
  gridTemplateColumns: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(3, 1fr)",
    md: "repeat(4, 1fr)",
  },
  gap: "1rem",
};

const statCard = {
  padding: "1rem",
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  border: "1px solid #e5e7eb",
  transition: "all 0.2s ease",
  "&:hover": {
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    borderColor: "#d1d5db",
  },
};

const statLabelTypography = {
  color: "#6b7280",
  fontSize: "0.75rem",
  fontWeight: 500,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  marginBottom: "0.5rem",
};

const statValueTypography = {
  color: "#111827",
  fontSize: "1.5rem",
  fontWeight: 600,
  lineHeight: 1.2,
};

const rateStatCard = {
  ...statCard,
  backgroundColor: "#f9fafb",
};

const stepSubjectsContainer = {
  marginBottom: 0,
};

const stepSubjectsLabel = {
  color: "#6b7280",
  marginBottom: "0.5rem",
  fontWeight: 600,
  fontSize: "0.75rem",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const stepSubjectItem = {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  marginBottom: "0.375rem",
  padding: "0.375rem 0.5rem",
  backgroundColor: "#ffffff",
  borderRadius: "6px",
  border: "1px solid #e5e7eb",
};

const stepChip = {
  backgroundColor: "#f2f764",
  color: "#1f2937",
  fontWeight: 600,
  fontSize: "0.7rem",
  height: "20px",
  minWidth: "50px",
  borderRadius: "4px",
};

const stepSubjectText = {
  flex: 1,
  color: "#374151",
  fontSize: "0.8125rem",
  fontWeight: 400,
};

const usersTableHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "1rem",
};

const usersTableTitle = {
  fontWeight: "bold",
};

const filteredResultsTypography = {
  color: "gray",
  marginLeft: "0.5rem",
  fontWeight: "normal",
};

const actionsBox = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "1rem",
};

const exportButton = {
  textTransform: "none",
};

const loaderBox = {
  display: "flex",
  justifyContent: "center",
  padding: "2rem",
};

const emptyStatePaper = {
  padding: "3rem",
  textAlign: "center",
  borderRadius: "8px",
  border: "2px dashed lightgray",
  backgroundColor: "#fafafa",
};

const emptyStateTypography = {
  color: "gray",
  marginBottom: "2rem",
};

const campaignLoaderBox = {
  display: "flex",
  justifyContent: "center",
  padding: "4rem",
};

const notFoundBox = {
  padding: "2rem",
  textAlign: "center",
};

const notFoundTitleTypography = {
  color: "gray",
  marginBottom: "1rem",
};

const notFoundBodyTypography = {
  color: "gray",
};

const hiddenCsvLink = {
  display: "none",
};

const statusSection = {
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  flexWrap: "wrap",
};

const statusChip = {
  fontWeight: 500,
  fontSize: "11px",
  height: "28px",
  borderRadius: "4px",
  backgroundColor: "#f3f4f6",
  color: "#374151",
};

const actionButton = {
  textTransform: "none",
  backgroundColor: "#367598",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "#2d5f7a",
  },
};

export {
  containerBox,
  overviewPaper,
  headerSection,
  titleSection,
  titleTypography,
  sourceChip,
  infoSection,
  subjectText,
  senderEmailText,
  senderEmailsContainer,
  senderEmailsLabel,
  senderEmailsList,
  senderEmailChip,
  divider,
  statsGrid,
  statCard,
  statLabelTypography,
  statValueTypography,
  rateStatCard,
  usersTableHeader,
  usersTableTitle,
  filteredResultsTypography,
  actionsBox,
  exportButton,
  loaderBox,
  emptyStatePaper,
  emptyStateTypography,
  campaignLoaderBox,
  notFoundBox,
  notFoundTitleTypography,
  notFoundBodyTypography,
  hiddenCsvLink,
  stepSubjectsContainer,
  stepSubjectsLabel,
  stepSubjectItem,
  stepChip,
  stepSubjectText,
  statusSection,
  statusChip,
  actionButton,
};
